module.exports = __webpack_public_path__ + "static/media/MtSutro.46370efb.png";